const isFunction = (value) => {
  return typeof value === "function";
};
const isFiniteNumber = (value) => Number.isFinite(value);
const getRandomID = () => {
  if (isFunction(crypto.randomUUID)) {
    return crypto.randomUUID();
  }
  return ((/* @__PURE__ */ new Date()).getTime() + Math.random()).toString(36);
};
const noop = () => {
};
const isFocusVisible = (el) => {
  return Boolean(el == null ? void 0 : el.matches(":focus-visible"));
};
export {
  getRandomID,
  isFiniteNumber,
  isFocusVisible,
  isFunction,
  noop
};
